import { apiTypes } from 'ui/api'

export const equipmentTypeOptions: {
	value: apiTypes.ShipmentResponse['equipmentType']
}[] = [{ value: 'F' }, { value: 'R' }, { value: 'V' }]
